module.exports = __webpack_public_path__ + "static/media/fire.61d56e29.png";